import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Objectives from './components/Objectives';
import LogicalFramework from './components/LogicalFramework';
import ExecutionPlan from './components/ExecutionPlan';
import Schedule from './components/Schedule';
import WorkContent from './components/WorkContent';
import Roles from './components/Roles';
import Budget from './components/Budget';
import KPIs from './components/KPIs';
import Stakeholders from './components/Stakeholders';
import RiskManagement from './components/RiskManagement';
import Exhibition from './components/Exhibition';
import Team from './components/Team';
import Partners from './components/Partners';
import Registration from './components/Registration';
import Contact from './components/Contact';
import Navbar from './components/Navbar';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white" dir="rtl">
      <Navbar scrolled={scrolled} />
      <Hero />
      <About />
      <Objectives />
      <LogicalFramework />
      <ExecutionPlan />
      <Schedule />
      <WorkContent />
      <Roles />
      <Budget />
      <KPIs />
      <Stakeholders />
      <RiskManagement />
      <Exhibition />
      <Team />
      <Partners />
      <Registration />
      <Contact />
    </div>
  );
}
